import { render, staticRenderFns } from "./modifyTheRecord.vue?vue&type=template&id=6315b21d"
import script from "./modifyTheRecord.vue?vue&type=script&lang=js"
export * from "./modifyTheRecord.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports